// extracted by mini-css-extract-plugin
export default {"like":"index_like_Aw3eb","likeCount":"index_likeCount_vZ0Jm","likeIcon":"index_likeIcon_OKcRb","liked":"index_liked_wiHNc"};